const ANICH_SLUGS = new Set(['fanich', 'anich']);

export const getPharmacyDisplayName = (pharmacy) => {
	if (pharmacy == null || typeof pharmacy === 'object') return '';

	const normalized = String(pharmacy).trim();
	const slug = normalized.toLowerCase();

	if (ANICH_SLUGS.has(slug)) return 'Anich';

	return normalized;
};

export const resolveLandingPharmacySlug = ({ platform, pageData, userPharmacy }) => {
	return pageData?.[0]?.root_pharmacy || platform || userPharmacy || null;
};
